import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { PendingComponent } from '@modules/core/components/PendingComponent';
import { ProposalCreationSlidoAe } from './ae';
import { ProposalCreationSlidoEs } from './es';
import { ProposalCreationSlidoProps } from './types';

export const ProposalCreationSlido = ({
  hideTabs = false,
  tab = 'newClient',
  existingClientData,
  actionButton,
}: ProposalCreationSlidoProps) => {
  const { isFeatureFlagsLoading, isFeatureActive } = useFeatureFlags();
  const isSpain = isFeatureActive('proposals.baytecaMVP');

  if (isFeatureFlagsLoading) {
    return <PendingComponent />;
  }
  if (isSpain) {
    return (
      <ProposalCreationSlidoEs
        hideTabs={ hideTabs }
        tab={ tab }
        existingClientData={ existingClientData }
      />
    );
  }
  return (
    <ProposalCreationSlidoAe
      hideTabs={ hideTabs }
      tab={ tab }
      existingClientData={ existingClientData }
      actionButton={ actionButton }
    />
  );
};
